$(document).on('change', '.rc_widget .rc_widget__option .rc_widget__option__input', function(){
	var $checked = $('.rc_widget .rc_widget__option .rc_widget__option__input:checked'),
	$price = $checked.closest('label').find('.rc-option__price').html();
	$('.product-price-value').html($price);
	var $originalPrice = $('#original_price').val();
	if(!$('.recharge-one-time-price').length) {
		$('.rc-option__subsave .rc-option__price').append('<span class="recharge-one-time-price">' + $originalPrice + '</span>');
	}
	discountedPrice();
	if($checked.closest('.rc-radio').hasClass('rc-option__subsave')) {
		$('.rc-selling-plans').addClass('selling-plan-selected');
		let originalPriceHtml = $('.rc-option__onetime .rc-option__price').text()
		if(originalPriceHtml === ""){
			originalPriceHtml = $originalPrice;
		}
		var $originalPrice = parseInt(originalPriceHtml.replace(/[,$]/g, "")),
		$discount = 1 - parseInt($('.rc-option__subsave .rc-option__discount').text())/100,
		$discountedPrice = $discount * $originalPrice,
		$discountedPrice = '$' + $discountedPrice.toFixed(2);
		$currentPrice = $discountedPrice;
	} else {
		$('.rc-selling-plans').removeClass('selling-plan-selected');
		$currentPrice = $originalPrice;
	}
	var $classes = $('.recharge-inner-most-price').attr('class');
	$('.recharge-inner-most-price')
		.removeAttr('class')
		.html($currentPrice)
		.addClass('temporary-for-update');
	setTimeout(function(){
		$('.temporary-for-update')
			.addClass($classes)
			.removeClass('temporary-for-update');
	}, 500);
});

$(document).on('change', '.rc-selling-plans .rc_widget__option__plans__dropdown', function(){
	var $originalPrice = $('#original_price').val();
	$('.rc-option__onetime .rc_widget__price--onetime').html($originalPrice);
	discountedPrice();
});

$(document).ready(function(){
	var $recharge = $('#recharge_available').val();
	if($recharge) {
		var $interval = setInterval(function(){
			var $widget = $('.rc-container-wrapper');
			if($widget.length) {
				updateWidget();
				clearInterval($interval);
			}
		}, 500);
	}
});

function updateWidget() {
	var $originalPrice = $('.recharge-inner-most-price').text();
	var $discountLabel = $('#recharge_label_1').length && $('#recharge_label_1').val()
		? $('#recharge_label_1').val()
		: "Edit, pause, skip or cancel at any time";
	var $deliveryLabel = $('#recharge_label_2').length && $('#recharge_label_2').val()
		? $('#recharge_label_2').val()
		: 'Extra Insider rewards on your first 2 deliveries';
	var $returnsLabel = $('#recharge_label_3').length && $('#recharge_label_3').val()
		? $('#recharge_label_3').val()
		: 'Free 30-day returns';
	if($('#subscribe_label').length) {
		$discountLabel = $('#subscribe_label').val();
	}
	var sub_html = '';
	if($('#subscribe_label_2').length) {
		sub_html += '<span class="rc-option-custom-labels">' + $('#subscribe_label_2').val() + '</span>';
	}
	if($('#subscribe_label_3').length) {
		sub_html += '<span class="rc-option-custom-labels">' + $('#subscribe_label_3').val() + '</span>';
	}
	$('.rc-option__subsave .rc-option__price').append('<span class="recharge-one-time-price">' + $originalPrice + '</span>');
	$('.rc-option__onetime .rc-option__price').html($originalPrice);
	$('.rc-option__subsave').append(
		'<span class="rc-option-custom-labels">' + $discountLabel + '</span>' +
		sub_html +
		'<span class="rc-option-custom-labels">' + $deliveryLabel + '</span>' +
		'<span class="rc-option-custom-labels">' + $returnsLabel + '</span>'
	);
	discountedPrice();
}

function discountedPrice() {
	var $originalPrice = parseInt($('#original_price').val().replace(/[,$]/g, "")),
	$discount = 1 - parseInt($('.rc-option__subsave .rc-option__discount').text())/100,
	$discountedPrice = $discount * $originalPrice;
	$discountedPrice = '$' + $discountedPrice.toFixed(2);
	$originalPrice = '$' + $originalPrice.toFixed(2);
	var $html = $discountedPrice + '<span class="recharge-one-time-price">' + $originalPrice + '</span>';
	$('.rc-option__subsave .rc-option__price').html($html);
}

$(document).on('click', '.add-set-to-cart', function(){
	addToCart();
});

function addToCart() {
	const _timestamp = new Date().getTime();
	var $data = [];
	let productsInBundle = 0;
	const parentProductJson = JSON.parse($('script#parent-product-json').html());
	let childIds = [];
	let childProductNames = [];
	$('.main-set-product').each(function(){
		var $this = $(this);
		if($this.find('.set-property').length) {
			$variant = $this.find('.set-property:checked').data('variant-id');
			$variantImage = $this.find('.set-property:checked').data('image');
		} else {
			$variant = $this.data('variant-id');
			$variantImage = $this.data('image');
		}
		const $name = $this.data('name') + '|' + $this.data('type') + '||' + $this.find('.set-property:checked').data('image');
		$data.push({
			"quantity": 1,
			"id": $variant,
			properties: {
				_unique_bundle_id: _timestamp,
				"_bundle_product": "Yes",
			}
		});
		childIds.push($variant);
		childProductNames.push($name);
		productsInBundle++;
	});
	const parentVariant = $('.add-set-to-cart').data('variant');
	$data.push({
		"quantity": 1,
		"id": parentVariant,
		properties: {
			_unique_bundle_id: _timestamp,
			"_bundle_product": "Yes",
		}
	});
	const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart_holder.getSectionsToRender().map((section) => section.id);
	cart_holder.setActiveElement(document.getElementById('CartDrawer'));
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data,
			sections,
			sections_url: window.location.pathname + (window.location.search || '')
		},
		success: function(response) {
			if(response.status){
				alert(response.description || 'An error has occurred.');
				return;
			}
			if(cart_holder && cart_holder.classList.contains('is-empty')){ cart_holder.classList.remove('is-empty'); }
			cart_holder.renderContents(response);
		},
		error: function(response) {
			if(response){
				alert(response?.responseJSON?.description || 'An error has occurred.');
				return;
			}
		}
	});
}

$(document).on('change input', '.main-set-product .ms-option-values input', function(){
	var $this = $(this),
	$image = $this.closest('.ms-option-values').find('input:checked').data('image'),
	$target = $this.closest('.main-set-product').find('.ms-image img');
	$target.attr('src', " ");
	$target.attr('src', $image);
});

$(document).ready(function(){
	if($('body').hasClass('template-product-set')) {
		$('.ms-option-values').each(function(){
			var $this = $(this),
			$image = $this.find('input:checked').data('image'),
			$target = $this.closest('.main-set-product').find('.ms-image img');
			$target.attr('src', " ");
			$target.attr('src', $image);
		});
	}
});

$(document).on('click', '.customer-reviews-meta a', function(){
	var $this = $(this),
	$target = $('.' + $this.attr('href')),
	$offset = $target.offset().top;
	$('html, body').animate({ 'scrollTop': $offset });
	return false;
});

$(document).on('click', '.accordion-title li:not(.active-accordion) a', function(){
	var $this = $(this),
	$target = $('#' + $this.attr('href')),
	$parent = $this.closest('li');
	$('.active-accordion').removeClass('active-accordion');
	$parent.addClass('active-accordion');
	$('.accordion-content-item').hide();
	$target.show();
	return false;
});

$(document).on('click', '.go-to-full-desc', function(){
	$('.description-accordion a').trigger('click');
	var $offset = $('.description-accordion').offset().top;
	$('html, body').animate({ 'scrollTop': $offset });
});

$(document).on('click', '.ui-upsell-title li:not(.active-upsell) a', function(){
	var $this = $(this),
	$target = $($this.attr('href')),
	$parent = $this.closest('li');
	$this.closest('.upsell-content').find('.active-upsell').removeClass('active-upsell');
	$this.closest('.upsell-content').find('.upsell-tab-item').hide();
	$parent.addClass('active-upsell');
	$target.show();
	return false;
});

$(document).on('click', '.view-all-items', function(){
	var $this = $(this);
	if($this.hasClass('view-less-items')) {
		$this.removeClass('view-less-items');
		$this.text('View More');
		$this.closest('.upsell-tab-item').find('.hidden-upsell-items').slideUp();
	} else {
		$this.addClass('view-less-items');
		$this.text('View Less');
		$this.closest('.upsell-tab-item').find('.hidden-upsell-items').slideDown();
	}
	return false;
});

$(document).on('click', '.full-ing-button', function(){
	$('#modal-full-ing').addClass('is-open');
});

$(document).on('click', '#modal-full-ing .modal__footer button', function(){
	$('#modal-full-ing').removeClass('is-open');
});

$(document).on('click', '.ui-add-cart', function(){
	var $this = $(this),
	$variant = $this.data('variant');
	$this.html('Adding');
	var $data = [];
	$data.push({ "quantity": 1, "id": $variant });
	const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart_holder.getSectionsToRender().map((section) => section.id);
	cart_holder.setActiveElement(document.getElementById('CartDrawer'));
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data,
			sections,
			sections_url: window.location.pathname + (window.location.search || '')
		},
		success: function(response) {
			if(response.status){
				alert(response.description || 'An error has occurred.');
				return;
			}
			if(cart_holder && cart_holder.classList.contains('is-empty')){ cart_holder.classList.remove('is-empty'); }
			cart_holder.renderContents(response);
			$this.html('Added');
		},
		error: function(response) {
			if(response){
				alert(response?.responseJSON?.description || 'An error has occurred.');
				return;
			}
		}
	});
});

$(document).on('change', '.shade-option-container input', function(){
	var $this = $(this),
	$val = $this.val();
	$('.shade-name').html($val);
});

(function($) {
	let swiper;
	$(document).on('change', '.shade-option-container input', function(){
		var $this = $(this);
		if ($('.product--stacked').length) {
			var $val = $this.data('value'),
			$target = $(".product--stacked li." + $val);
			if ($target.length) {
				$('.product--stacked li').addClass('slides-hidden');
				$target.removeClass('slides-hidden');
			} else {
				$('.product--stacked li').removeClass('slides-hidden');
			}
			if (!swiper) {
				swiper = new Swiper('.product__media-slider', {
					loop: false,
					slidesPerView: 1,
					spaceBetween: 20,
					navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
					scrollbar: { el: '.swiper-scrollbar' }
				});
			} else {
				swiper.destroy();
				swiper = new Swiper('.product__media-slider', {
					loop: false,
					slidesPerView: 1,
					spaceBetween: 20,
					navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
					scrollbar: { el: '.swiper-scrollbar' }
				});
			}
		}
	});
})(jQuery);

$(document).on('click', '.product-form__input input', function(){
	restoreBundleSelection();
	var $this = $(this),
	$val = $this.val();
	$handle = $val.toLowerCase().trim().replace(/\s+/g, '-');
	$('.product__media-item').addClass('slides-hidden');
	$('.product__title h1').text($('.product__title').data('title'));
	setTimeout(function(){
		if($('.' + $handle + '-variant').length) {
			$('.product__media-item').addClass('slides-hidden');
			$('.' + $handle + '-variant').removeClass('slides-hidden');
			$('.product__media-item.is-active').removeClass('slides-hidden');
		} else {
			$('.product__media-item').removeClass('slides-hidden');
			$('.product__media-item[class*="-variant"]').addClass('slides-hidden');
			$('.product__media-item[class*="--variant"]').removeClass('slides-hidden');
		}
	});
	updateRefillTag();
	rechargeAutoSelect();
});

function updateRefillTag() {
	var $tag = $('span[data-tag-handle="refillable"]');
	if($tag.length) {
		var $originalText = $tag.data('value');
		var currentVariant = getCurrentSelectionTitle();
		$tag.hide();
		if(isCurrentSelectionRefill()) {
			$tag.show();
			$tag.text('Refill Only');
		} else if(currentVariant == 'Full Size') {
			$tag.show();
			$tag.text($originalText);
		}
	}
}

function toggleRefillUi(isRefill) {
	if($('.refill-messaging').length) {
		if(isRefill) {
			$('.refill-messaging').css('display', 'flex');
		} else {
			$('.refill-messaging').hide();
		}
	}
	if($('.rc-container-wrapper').length) {
		if(isRefill) {
			$('.rc-container-wrapper').show();
		} else {
			$('.rc-container-wrapper').hide();
		}
	}
}

function rechargeAutoSelect(callback) {
	var done = false;
	function tryRun() {
		if (done) return;
		var success = preselectRechargeOption();
		if (success) {
			done = true;
			if (typeof callback === 'function') callback();
			return true;
		}
		return false;
	}
	var wrapper = document.querySelector('.rc-container-wrapper') || document.body;
	if (window.MutationObserver) {
		var observer = new MutationObserver(function() {
			if (tryRun()) {
				observer.disconnect();
				clearInterval(pollInterval);
			}
		});
		observer.observe(wrapper, { childList: true, subtree: true });
	}
	var attempts = 0;
	var pollInterval = setInterval(function() {
		attempts++;
		if (tryRun() || attempts >= 40) {
			clearInterval(pollInterval);
			if (window.MutationObserver && observer) {
				try { observer.disconnect(); } catch(e){}
			}
		}
	}, 250);
	setTimeout(function() { tryRun(); }, 1000);
}

function preselectRechargeOption() {
	var $sub = $('.rc-option__subsave');
	var $one = $('.rc-option__onetime');
	var isRefill = isCurrentSelectionRefill();
	toggleRefillUi(isRefill);
	if (!$sub.length || !$one.length) { return false; }
	if (isRefill) {
		setTimeout(function(){ $sub.click(); }, 100);
	} else {
		setTimeout(function(){ $one.click(); }, 100);
	}
	return true;
}

function getSelectedVariantTitle() {
	var $sel = $('.product-form__input input:checked');
	if ($sel.length) {
		var txt = $.trim($sel.val());
		if (txt) return txt;
	}
	return '';
}

function getCurrentSelectionTitle() {
	if(currentBundleOverride && currentBundleOverride.title) {
		return currentBundleOverride.title;
	}
	return getSelectedVariantTitle();
}

function isCurrentSelectionRefill() {
	if(currentBundleOverride && typeof currentBundleOverride.isRefill !== 'undefined') {
		return currentBundleOverride.isRefill === true;
	}
	return /refill/i.test(getCurrentSelectionTitle());
}

$(document).ready(function(){
	var $val = $('.product-form__input input:checked').val();
	if($val) {
		$handle = $val.toLowerCase().trim().replace(/\s+/g, '-');
		$('.product__media-item').addClass('slides-hidden');
		setTimeout(function(){
			if($('.' + $handle + '-variant').length) {
				$('.product__media-item').addClass('slides-hidden');
				$('.' + $handle + '-variant').removeClass('slides-hidden');
				$('.product__media-item.is-active').removeClass('slides-hidden');
			} else {
				$('.product__media-item').removeClass('slides-hidden');
				$('.product__media-item[class*="-variant"]').addClass('slides-hidden');
				$('.product__media-item[class*="--variant"]').removeClass('slides-hidden');
			}
		});
		updateRefillTag();
		rechargeAutoSelect();
		setTimeout(function(){ rechargeAutoSelect(); }, 1200);
	}
});

Shopify.formatMoney = function(cents, format) {
	if (typeof cents === 'string') { cents = cents.replace('.', ''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	this.money_format = this.money_format || false;
	var formatString = format || this.money_format;
	var defaultOption = function(opt, def) { return (typeof opt === 'undefined' ? def : opt); };
	var formatWithDelimiters = function(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');
		if (isNaN(number) || number == null) { return 0; }
		number = (number / 100.0).toFixed(precision);
		var parts = number.split('.'),
		dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
		cents = parts[1] ? (decimal + parts[1]) : '';
		return dollars + cents;
	};
	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount': value = formatWithDelimiters(cents, 2); break;
		case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
		case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
		case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
	}
	return formatString.replace(placeholderRegex, value);
};

$(document).ready(function() {
	var $sticky = $('.sticky-atc');
	var $variantSelect = $sticky.find('.sticky-atc__variant');
	var $price = $sticky.find('.sticky-atc__price');
	var $title = $sticky.find('.sticky-atc__title');
	var $image = $sticky.find('.sticky-atc__image');
	var $btn = $sticky.find('.sticky-atc__btn');
	var $btnSpan = $btn.find('span').first();
	var addToCartText = $btnSpan.text().trim();
	var soldOutText = $btn.data('sold-out') || 'Sold Out';
	function updateUI() {
		var selectedOption = $variantSelect.find('option:selected');
		if (!selectedOption.length) return;
		var imageSrc = selectedOption.data('image');
		if (imageSrc) { $image.attr('src', imageSrc); }
		var price = parseInt(selectedOption.data('price'), 10);
		var title = selectedOption.data('title');
		$price.html(Shopify.formatMoney(price, Shopify.money_format));
		$title.html(title);
		var available = selectedOption.data('available') === true;
		if (available) {
			$btn.prop('disabled', false);
			$btnSpan.text(addToCartText);
		} else {
			$btn.prop('disabled', true);
			$btnSpan.text(soldOutText);
		}
	}
	$variantSelect.on('change', function() { updateUI(); });
	$btn.on('click', function() {
		var variantId = $variantSelect.val();
		var cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		if (!cart_holder) return;
		$btnSpan.hide();
		$btn.find('.loading-overlay__spinner').removeClass('hidden');
		var sections = cart_holder.getSectionsToRender().map(function(section) { return section.id; });
		cart_holder.setActiveElement(document.getElementById('CartDrawer'));
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				items: [{ quantity: 1, id: variantId }],
				sections: sections,
				sections_url: window.location.pathname + (window.location.search || '')
			},
			dataType: 'json',
			success: function(response) {
				$btnSpan.show();
				$btn.find('.loading-overlay__spinner').addClass('hidden');
				if (response.status) { alert(response.description || 'An error has occurred.'); return; }
				if (cart_holder.classList.contains('is-empty')) { cart_holder.classList.remove('is-empty'); }
				cart_holder.renderContents(response);
			},
			error: function() {
				$btnSpan.show();
				$btn.find('.loading-overlay__spinner').addClass('hidden');
				$btn.prop('disabled', false);
				$btnSpan.text('Error — try again');
			}
		});
	});
});

$(window).on('scroll', function(){
	if($('.sticky-atc').length > 0) {
		var $top = $(window).scrollTop();
		if($top > 600) {
			$('.sticky-atc').addClass('show_sticky-atc');
		} else {
			$('.sticky-atc').removeClass('show_sticky-atc');
		}
	}
});

var activeBundleSelection = null;
var currentBundleOverride = null;
function getSectionId() {
	var $section = $('[id^="MainProduct-"]').first();
	if(!$section.length) { return ''; }
	return ($section.attr('id') || '').replace('MainProduct-', '');
}

function captureProductState() {
	var sectionId = getSectionId();
	return {
		title: $('.product__title').data('title') || $('.product__title h1').text(),
		type: $('.product__type').first().text().trim(),
		variantId: $('form[id^="product-form-"] input[name="id"]').first().val(),
		waitlistVariantId: $('#variant_val').val() || '',
		originalPrice: $('#original_price').val() || '',
		priceHtml: $('#price-' + sectionId + ' .price').first().html() || '',
		priceClass: $('#price-' + sectionId + ' .price').attr('class') || '',
		weightHtml: $('#price-' + sectionId + ' .product__weight').length
			? $('#price-' + sectionId + ' .product__weight').first().prop('outerHTML')
			: '',
		unitWeight: $('.product__unit').first().html() || '',
		buttonDisabled: $('.product-form__submit[type="submit"]').prop('disabled'),
		buttonLabel: $('.product-form__submit[type="submit"] span').first().text().trim(),
		galleryMobileHtml: (function() {
			var $el = $('#Slider-' + sectionId + '.swiper-wrapper');
			if (!$el.length) $el = $('#Slider-' + sectionId);
			return $el.html() || '';
		})(),
		galleryDesktopHtml: $('#Slider-Gallery-' + sectionId).html() || '',
		galleryThumbnailsHtml: $('#Slider-Thumbnails-' + sectionId).html() || '',
		galleryFullscreenHtml: $('#swiper-full-slider .swiper-wrapper').html() || ''
	};
}

function updateFullGallery($template, title) {
	if (!$template || !$template.length) return;
	var sectionId = getSectionId();
	var templateNode = $template[0];
	var $imgs = templateNode.content
		? $(templateNode.content).find('img')
		: $template.find('img');
	if (!$imgs.length) return;
	var mobileHtml = '';
	$imgs.each(function(i) {
		var imgHtml = this.outerHTML;
		mobileHtml +=
			'<li class="product__media-item grid__item slider__slide product__media-item--full carousel__item swiper-slide" data-media-id="' + sectionId + '-bundle-' + i + '">' +
				'<div class="product__media media media--transparent media--adapt">' +
					imgHtml +
				'</div>' +
			'</li>';
	});
	var $mobileWrapper = $('#Slider-' + sectionId + '.swiper-wrapper');
	if (!$mobileWrapper.length) $mobileWrapper = $('#Slider-' + sectionId);
	if ($mobileWrapper.length) $mobileWrapper.html(mobileHtml);
	var desktopHtml = '';
	$imgs.each(function(i) {
		var imgHtml = this.outerHTML;
		var activeClass = i === 0 ? ' is-active' : '';
		desktopHtml +=
			'<li id="Slide-' + sectionId + '-bundle-' + i + '" class="product__media-item grid__item slider__slide product__media-item--full carousel__item' + activeClass + '" data-media-id="' + sectionId + '-bundle-' + i + '">' +
				'<div class="product__media media media--transparent media--adapt">' +
					imgHtml +
				'</div>' +
			'</li>';
	});
	var $desktopList = $('#Slider-Gallery-' + sectionId);
	if ($desktopList.length) $desktopList.html(desktopHtml);
	var thumbHtml = '';
	$imgs.each(function(i) {
		var altText = $(this).attr('alt') || title || '';
		var thumbImg = $(this).clone()
			.attr({ width: 200, height: 200, loading: 'lazy' })
			.removeClass()
			.addClass('small-hide')
			.prop('outerHTML');
		thumbHtml +=
			'<li id="Slide-Thumbnails-' + sectionId + '-' + i + '" class="thumbnail-list__item slider__slide" data-target="' + sectionId + '-bundle-' + i + '" data-media-position="' + (i + 1) + '">' +
				'<button class="thumbnail global-media-settings global-media-settings--no-shadow thumbnail--narrow"' +
					' aria-label="' + altText + '"' +
					' aria-controls="GalleryViewer-' + sectionId + '"' +
					' aria-current="' + (i === 0 ? 'true' : 'false') + '">' +
					thumbImg +
				'</button>' +
			'</li>';
	});
	var $thumbList = $('#Slider-Thumbnails-' + sectionId);
	if ($thumbList.length) {
		$thumbList.html(thumbHtml);
		$thumbList.find('.thumbnail').off('click.bundle').on('click.bundle', function() {
			var pos = parseInt($(this).closest('li').data('media-position')) - 1;
			$thumbList.find('.thumbnail').attr('aria-current', 'false');
			$(this).attr('aria-current', 'true');
			var $slide = $desktopList.find('li').eq(pos);
			if ($slide.length) {
				$slide[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
			}
		});
	}
	var fullscreenHtml = '';
	$imgs.each(function(i) {
		var fullImg = $(this).clone()
			.attr({ width: 1200, height: 1200 })
			.prop('outerHTML');
		fullscreenHtml +=
			'<div class="swiper-slide">' +
				'<div class="product__media media media--transparent media--adapt">' +
					fullImg +
				'</div>' +
			'</div>';
	});
	var $fullSlider = $('#swiper-full-slider .swiper-wrapper');
	if ($fullSlider.length) $fullSlider.html(fullscreenHtml);
	reinitSwiper();
}

function reinitSwiper() {
	var sectionId = getSectionId();
	var swiperEl = document.querySelector('#swiper-' + sectionId);
	if (!swiperEl) swiperEl = document.querySelector('.product__media-slider.swiper');
	if (swiperEl && swiperEl.swiper) {
		swiperEl.swiper.destroy(true, true);
	}
	if (swiperEl) {
		new Swiper(swiperEl, {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
			scrollbar: { el: '.swiper-scrollbar' }
		});
	}
}

function updateProductVariantId(variantId) {
	if(!variantId) { return; }
	$('form[id^="product-form-"] input[name="id"]').val(variantId);
	if($('#variant_val').length) { $('#variant_val').val(variantId); }
}

function updateProductType(typeText) {
	if(typeof typeText === 'undefined') { return; }
	$('.product__type').text(typeText);
}

function updateProductPrice(priceText, comparePriceText, isAvailable) {
	var sectionId = getSectionId();
	if(!sectionId) { return; }
	var $price = $('#price-' + sectionId + ' .price').first();
	if(!$price.length) { return; }
	$price.removeClass('price--on-sale price--sold-out');
	if(!isAvailable) { $price.addClass('price--sold-out'); }
	if(comparePriceText) { $price.addClass('price--on-sale'); }
	$price.find('.price__regular .price-item--regular').text(priceText);
	$price.find('.price__sale .price-item--sale').text(priceText);
	$price.find('.price__sale s.price-item--regular').text(comparePriceText || '');
}

function updateProductWeight(weightValue, weightUnit, unitWeight) {
	var sectionId = getSectionId();
	if(sectionId) {
		var $priceWrapper = $('#price-' + sectionId);
		var $weight = $priceWrapper.find('.product__weight').first();
		var hasVariantWeight = weightValue && parseFloat(weightValue) !== 0;
		if(hasVariantWeight) {
			if($weight.length) {
				$weight.text(weightValue + ' ' + weightUnit);
			} else {
				$priceWrapper.append('<div class="product__weight testing">' + weightValue + ' ' + weightUnit + '</div>');
			}
		} else {
			$weight.remove();
		}
	}
	if(typeof unitWeight !== 'undefined') {
		$('.product__unit').html(unitWeight || '');
	}
}

function updateAddToCartButton(isAvailable) {
	var $button = $('.product-form__submit[type="submit"]').first();
	if(!$button.length) { return; }
	if(isAvailable) {
		$button.prop('disabled', false);
	} else {
		var soldOutText = $button.data('sold-out') || 'Sold Out';
		$button.prop('disabled', true);
		$button.find('span').first().text(soldOutText);
	}
}

function restoreBundleSelection() {
	$('.active-bundle-link').removeClass('active-bundle-link');
	if(!activeBundleSelection) { return; }
	currentBundleOverride = null;
	var sectionId = getSectionId();
	$('.product__title h1').text(activeBundleSelection.title);
	updateProductType(activeBundleSelection.type);
	updateProductVariantId(activeBundleSelection.variantId);
	if($('#variant_val').length && activeBundleSelection.waitlistVariantId) {
		$('#variant_val').val(activeBundleSelection.waitlistVariantId);
	}
	if($('#original_price').length) {
		$('#original_price').val(activeBundleSelection.originalPrice);
	}
	if(sectionId) {
		var $price = $('#price-' + sectionId + ' .price').first();
		if($price.length) {
			$price.attr('class', activeBundleSelection.priceClass);
			$price.html(activeBundleSelection.priceHtml);
		}
		$('#price-' + sectionId + ' .product__weight').remove();
		if(activeBundleSelection.weightHtml) {
			$('#price-' + sectionId).append(activeBundleSelection.weightHtml);
		}
	}
	$('.product__unit').html(activeBundleSelection.unitWeight);
	if(activeBundleSelection.galleryDesktopHtml) {
		$('#Slider-Gallery-' + sectionId).html(activeBundleSelection.galleryDesktopHtml);
	}
	if(activeBundleSelection.galleryMobileHtml) {
		var $mobileWrapper = $('#Slider-' + sectionId + '.swiper-wrapper');
		if (!$mobileWrapper.length) $mobileWrapper = $('#Slider-' + sectionId);
		if ($mobileWrapper.length) $mobileWrapper.html(activeBundleSelection.galleryMobileHtml);
	}
	if(activeBundleSelection.galleryThumbnailsHtml) {
		$('#Slider-Thumbnails-' + sectionId).html(activeBundleSelection.galleryThumbnailsHtml);
	}
	if(activeBundleSelection.galleryFullscreenHtml) {
		$('#swiper-full-slider .swiper-wrapper').html(activeBundleSelection.galleryFullscreenHtml);
	}
	reinitSwiper();
	$('.product-form__submit[type="submit"]').first().prop('disabled', activeBundleSelection.buttonDisabled);
	if(activeBundleSelection.buttonLabel) {
		$('.product-form__submit[type="submit"] span').first().text(activeBundleSelection.buttonLabel);
	}
	activeBundleSelection = null;
}

$(document).on('click', '.custom-bundle-link', function(){
	var $this = $(this),
	$title       = $this.data('title'),
	$type        = $this.data('type'),
	$price       = $this.data('price'),
	$comparePrice= $this.data('compare-price'),
	$weightValue = $this.data('weight-value'),
	$weightUnit  = $this.data('weight-unit'),
	$unitWeight  = $this.data('unit-weight'),
	$isRefill    = $this.data('is-refill'),
	$variantId   = $this.data('variant-id'),
	$isAvailable = $this.data('available');
	$('.custom-bundle-link').removeClass('active-bundle-link');
	$this.addClass('active-bundle-link');
	if(!activeBundleSelection) {
		activeBundleSelection = captureProductState();
	}
	currentBundleOverride = {
		title: $title,
		isRefill: $isRefill === true || $isRefill === 'true'
	};
	$('.product__title h1').text($title);
	updateProductType($type);
	var $template = $this.next('.bundle-gallery-template');
	updateFullGallery($template, $title);
	updateProductVariantId($variantId);
	updateProductPrice($price, $comparePrice, $isAvailable);
	updateProductWeight($weightValue, $weightUnit, $unitWeight);
	if($('#original_price').length) {
		$('#original_price').val($price);
	}
	updateAddToCartButton($isAvailable);
	$('.product-form__input input').prop('checked', false);
	updateRefillTag();
	rechargeAutoSelect();
});